import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatCurrency = (value) => {
  if (!value && value !== 0) return '-';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

export const formatArea = (value, unit = 'm²') => {
  if (!value && value !== 0) return '-';
  return `${new Intl.NumberFormat('pt-BR').format(value)} ${unit}`;
};

export const formatPhone = (phone) => {
  if (!phone) return '';
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 11) {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7)}`;
  }
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
  }
  return phone;
};

export const getWhatsAppLink = (phone, message = '') => {
  const cleaned = phone.replace(/\D/g, '');
  const fullNumber = cleaned.startsWith('55') ? cleaned : `55${cleaned}`;
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${fullNumber}${message ? `?text=${encodedMessage}` : ''}`;
};

export const propertyTypeLabels = {
  house: 'Casa',
  apartment: 'Apartamento',
  land: 'Terreno',
  commercial: 'Comercial',
  rural: 'Rural',
  chacara: 'Chácara',  
};

export const transactionTypeLabels = {
  sale: 'Venda',
  rent: 'Aluguel',
};

export const statusLabels = {
  available: 'Disponível',
  sold: 'Vendido',
  rented: 'Alugado',
  inactive: 'Inativo',
};

export const clientStatusLabels = {
  new: 'Novo',
  contacted: 'Contatado',
  visit_scheduled: 'Visita Agendada',
  proposal: 'Proposta',
  closed_won: 'Fechado (Ganho)',
  closed_lost: 'Fechado (Perdido)',
};

export const leadStatusLabels = {
  new: 'Novo',
  handled: 'Tratado',
  spam: 'Spam',
};

export const interactionTypeLabels = {
  call: 'Ligação',
  whatsapp: 'WhatsApp',
  visit: 'Visita',
  proposal: 'Proposta',
  note: 'Anotação',
};

export const getPropertyImage = (property, index = 0) => {

  // usa imagem destacada primeiro
  if (property.featured_image) {

    const featured = property.featured_image;

    if (featured.startsWith('http')) return featured;

    return `${process.env.REACT_APP_BACKEND_URL}${featured}`;
  }

  // fallback para imagens normais
  if (property.images && property.images.length > index) {

    const img = property.images[index];

    if (typeof img === 'string') {

      if (img.startsWith('http')) return img;

      return `${process.env.REACT_APP_BACKEND_URL}${img}`;
    }
  }

  // placeholders
  const placeholders = {
    house:
      'https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg?auto=compress&cs=tinysrgb&w=800',

    apartment:
      'https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg?auto=compress&cs=tinysrgb&w=800',

    land:
      'https://images.pexels.com/photos/440731/pexels-photo-440731.jpeg?auto=compress&cs=tinysrgb&w=800',

    commercial:
      'https://images.pexels.com/photos/260931/pexels-photo-260931.jpeg?auto=compress&cs=tinysrgb&w=800',

    rural:
      'https://images.pexels.com/photos/2132180/pexels-photo-2132180.jpeg?auto=compress&cs=tinysrgb&w=800',
  };

  return placeholders[property.property_type] || placeholders.house;
};

export const truncateText = (text, maxLength = 100) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength).trim() + '...';
};
